// Résolution partagée de la visibilité des onglets (Admin + Croquis Agenceur).
// Précédence : surcharge par utilisateur > config par rôle > défaut de base.

// Défauts de base des onglets Croquis Agenceur (avant surcharge éventuelle).
export function croquisBaseDefault(role, key) {
  if (role === 'super_admin') return true;
  if (key === 'croquis:reglages') return false; // Réglages : super_admin uniquement par défaut
  if (key === 'croquis:traiter') return role === 'admin'; // À traiter : admin (et super_admin) par défaut
  return true; // demande, historique : tout le monde
}

// Défaut de base générique : onglets Admin = visibles ; onglets Croquis = règle dédiée.
export function tabBaseDefault(role, key) {
  return String(key).startsWith('croquis:') ? croquisBaseDefault(role, key) : true;
}

export function resolveTabVisible(config, role, userId, key) {
  const uc = (config && config.user_config) || {};
  if (userId && uc[userId] && Object.prototype.hasOwnProperty.call(uc[userId], key)) return !!uc[userId][key];
  const rc = (config && config.role_config) || {};
  if (role && rc[role] && Object.prototype.hasOwnProperty.call(rc[role], key)) return !!rc[role][key];
  return tabBaseDefault(role, key);
}

// Libellés des onglets Croquis contrôlables dans la matrice Admin.
export const CROQUIS_TABS = [
  { key: 'croquis:demande', label: 'Croquis · Demande' },
  { key: 'croquis:traiter', label: 'Croquis · À traiter' },
  { key: 'croquis:historique', label: 'Croquis · Historique' },
  { key: 'croquis:reglages', label: 'Croquis · Réglages' },
];
